module.exports = __webpack_public_path__ + "static/media/sindy2.d32f2f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sindy2.png
// module id = 228
// module chunks = 2